import useSWR from 'swr';
import { backendClient } from '@/lib/api-client';
import type { User } from '@/lib/user';

// Custom fetcher for API requests
const fetcher = async (url: string) => {
  const response = await backendClient.get(url);
  return response.data;
};

const useAllUsers = () => {
  const { data, error, isLoading, mutate } = useSWR<User[]>(
    '/user/all',
    fetcher
  );

  return {
    users: data || [],
    isLoading,
    isError: error,
    mutateUsers: mutate
  };
};

export default useAllUsers;